import * as React from 'react';
const ModalDialogSizeContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ModalDialogSizeContext.displayName = 'ModalDialogSizeContext';
}
export default ModalDialogSizeContext;